import EcoSpace from 'eco-design/base/eco-space';
import { useMemo } from 'react';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoLink from 'eco-design/base/eco-link';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function Comp() {
    const { locale = 'us' } = getLocal();
    const { t } = useLang('theProduct.SectionB');
    const btnLink = useMemo(() => {
        switch (locale) {
            case 'us':
                return 'https://us.ecoflow.com/products/200-ecoflow-glacier-classic-extra-coupon';
            case 'ca':
                return 'https://ca.ecoflow.com/products/200-ecoflow-glacier-classic-extra-coupon';
            default:
                return '';
        }
    }, [locale]);
    return (
        <div className={styles.comp} id="SectionB">
            <EcoSpaceSmall />
            <div className="container">
                <div className="SectionB-info">
                    <div className="SectionB-title">{t('title')}</div>
                    <div className="SectionB-desc">{t('desc')}</div>
                    <EcoLink
                        className="SectionB-btn"
                        dataLayer={{ event: 'uaEvent', event_name: 'buy', product_name: 'none', position: `Product Detail_${t('title')}` }}
                        href={btnLink}
                    >
                        {t('btn')}
                    </EcoLink>
                </div>
                <img className="SectionB-img" src="https://websiteoss.ecoflow.com/upload/image/1744597105621/yhj-d.png" />
            </div>
            <EcoSpace />
        </div>
    );
}
